import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { MapPin } from "lucide-react";
import { useSettings } from "../../lib/useSettings";

export default function ZonesSection() {
  const { settings: s } = useSettings();
  const [zones, setZones] = useState([]);
  useEffect(() => { api.get("/zones").then(r => setZones(r.data)).catch(()=>{}); }, []);

  const radius = s?.intervention_radius_km || 40;
  const city = s?.main_city || "votre ville";
  const departments = (s?.intervention_departments && s.intervention_departments.length > 0)
    ? s.intervention_departments
    : [];

  const areaText = departments.length > 0
    ? `Nous intervenons dans ${departments.length === 1 ? "le département " + departments[0] : "les départements : " + departments.join(", ")} pour tous vos besoins.`
    : `Nous intervenons dans un rayon de ${radius} km autour de ${city} pour tous vos besoins.`;

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="zones-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-sky)] font-semibold mb-3">Zones desservies</div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[color:var(--brand-navy)] leading-tight">
              {radius} km autour de {city}<br/>
              <span className="brand-gradient-text">partout où vous êtes.</span>
            </h2>
            <p className="mt-6 text-[hsl(var(--muted-foreground))] text-base md:text-lg leading-relaxed max-w-md">
              {areaText}
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
            {zones.map((z) => (
              <Link key={z.id} to={`/zones/${z.slug}`}
                className="group flex items-center gap-2 px-4 py-3 rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--muted))]/30 hover:bg-[color:var(--brand-navy)] hover:text-white transition-all"
                data-testid={`zone-link-${z.slug}`}
              >
                <MapPin className="w-3.5 h-3.5 flex-shrink-0 text-[color:var(--brand-sky)] group-hover:text-white"/>
                <div className="min-w-0">
                  <div className="text-sm font-semibold truncate">{z.city}</div>
                  <div className="text-xs opacity-70 font-mono">{z.postal_code}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
